import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter, unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer, {store, history} from "./slices";
import {disableReactDevTools} from '@fvilers/disable-react-devtools';
import config from "./config";
import * as Sentry from "@sentry/browser";

if (config.status === 'prod') {
	disableReactDevTools();
}

Sentry.init({ dsn:  process.env.REACT_APP_GLITCH_TIP_DSN, environment: config.status});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<Provider store={store}>
		<React.Fragment>
			<HistoryRouter history={history}>
				<App />
			</HistoryRouter>
		</React.Fragment>
	</Provider>
);